import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useSiteSettings, buildWhatsAppUrl } from '@/hooks/useSiteSettings';
import { trackWhatsAppClick } from '@/lib/gtag';

export default function WhatsAppFAB({ message }) {
    const s = useSiteSettings();
    const loc = useLocation();
    if (loc.pathname.startsWith('/admin')) return null;
    const finalMsg = message || 'Hi Kanbr, I want to know more about your modular products.';
    const url = buildWhatsAppUrl(s.whatsapp_number, finalMsg);
    return (
        <a
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackWhatsAppClick({ source: `fab:${loc.pathname}`, message: finalMsg })}
            data-testid="whatsapp-fab"
            className="fixed bottom-8 right-8 z-50 w-14 h-14 bg-green-500 text-white rounded-full shadow-xl flex items-center justify-center hover:bg-green-600 hover:scale-110 transition-transform"
            aria-label="Chat on WhatsApp"
        >
            <MessageCircle className="w-6 h-6" fill="currentColor" strokeWidth={0} />
        </a>
    );
}
